import { Image, Layout, Typography } from 'antd';
import React, { useEffect } from 'react';
import { Community } from "../components/Community";
import { Footer } from "../components/Footer";
import { Navigation } from "../components/Navigation";
import * as analytics from "../services/Analytics";

export function Blog() {

    useEffect(() => {
        analytics.openBlogPage();
    }, []);

    return (
        <Layout>
            <Navigation selectedItem="blog" />
            <Layout.Content className="layout-content">

                <div className="layout-content-element">
                    <Typography.Title level={2}>👍 Our first vote has ended!</Typography.Title>
                    <Typography.Paragraph type='secondary'>Mar 15, 2022</Typography.Paragraph>
                    <Typography.Paragraph>Prisoner owners have decided...</Typography.Paragraph>
                    <Typography.Paragraph>🥁</Typography.Paragraph>
                    <Typography.Paragraph>...to increase the maximum number of NFTs per account from 3 to 5.</Typography.Paragraph>
                    <Typography.Paragraph>Congratulations to all who voted! This feature is already available on the dashboard page.</Typography.Paragraph>
                    <div style={{ height: "12px" }} />
                    <Image src={require("../assets/blog/post_2022_03_15.png")} width={"240px"} style={{ border: "1px solid #262626" }} />
                </div>

                <div className="layout-content-element">
                    <Typography.Title level={2}>👍 Voting Space</Typography.Title>
                    <Typography.Paragraph type='secondary'>Mar 6, 2022</Typography.Paragraph>
                    <Typography.Paragraph>It's time for everyone with prisoners to make their first decision.</Typography.Paragraph>
                    <Typography.Paragraph>The voting space is waiting for you on the dashboard page.</Typography.Paragraph>
                    <Typography.Paragraph>🚀</Typography.Paragraph>
                    <div style={{ height: "12px" }} />
                    <Image src={require("../assets/blog/post_2022_03_06.png")} width={"240px"} style={{ border: "1px solid #262626" }} />
                </div>

                <div className="layout-content-element">
                    <Typography.Title level={2}>🚨 28 / 250</Typography.Title>
                    <Typography.Paragraph type='secondary'>Mar 5, 2022</Typography.Paragraph>
                    <Typography.Paragraph>Attention everyone. If you are free, then this will soon change.</Typography.Paragraph>
                    <Typography.Paragraph>The crypto police don't sleep.</Typography.Paragraph>
                    <Typography.Paragraph>There are currently 28 prisoners in the prison. And this is just the beginning.</Typography.Paragraph>
                    <Typography.Paragraph>👀</Typography.Paragraph>
                    <div style={{ height: "12px" }} />
                    <Image src={require("../assets/blog/post_2022_03_05.png")} width={"240px"} style={{ border: "1px solid #262626" }} />
                </div>

                <div className="layout-content-element">
                    <Typography.Title level={2}>🚩 Start of Development of Season «Two»</Typography.Title>
                    <Typography.Paragraph type='secondary'>Feb 26, 2022</Typography.Paragraph>
                    <Typography.Paragraph>Dear prisoners, from today the development of the season "Two" begins!</Typography.Paragraph>
                    <Typography.Paragraph>Thanks everyone for your ideas. You helped understand what the Crypto Space Prison should look like.</Typography.Paragraph>
                    <Typography.Paragraph>In the coming days, a concept document describing the next season will be published.</Typography.Paragraph>
                    <Typography.Paragraph>Please note that the first season is not over yet. You can still participate in the mini-game to get benefits next season.</Typography.Paragraph>
                    <Typography.Paragraph>⚡</Typography.Paragraph>
                    <div style={{ height: "12px" }} />
                    <Image src={require("../assets/blog/post_2022_02_26.png")} width={"240px"} style={{ border: "1px solid #262626" }} />
                </div>

                <div className="layout-content-element">
                    <Typography.Title level={2}>⚙ Sharp gears</Typography.Title>
                    <Typography.Paragraph type='secondary'>Feb 23, 2022</Typography.Paragraph>
                    <Typography.Paragraph>The chase just got harder.</Typography.Paragraph>
                    <Typography.Paragraph>Now sharp gears can knock you out with one touch.</Typography.Paragraph>
                    <Typography.Paragraph>The conditions have not changed. The top 20 players will receive extra benefits in the next season.</Typography.Paragraph>
                    <Typography.Paragraph>Hurry up to play the game before the chase becomes extremely difficult.</Typography.Paragraph>
                    <Typography.Paragraph>🚀</Typography.Paragraph>
                    <div style={{ height: "12px" }} />
                    <Image src={require("../assets/blog/post_2022_02_23.gif")} width={"240px"} style={{ border: "1px solid #262626" }} />
                </div>

                <div className="layout-content-element">
                    <Typography.Title level={2}>🙊 Nicknames</Typography.Title>
                    <Typography.Paragraph type='secondary'>Feb 13, 2022</Typography.Paragraph>
                    <Typography.Paragraph>There are no names in the space prison. The prisoner has only a serial number... and now also a nickname that everyone can choose on the <a href='/dashboard'>dashboard page</a>.</Typography.Paragraph>
                    <Typography.Paragraph>Please note that this must be done before the start of the next season.</Typography.Paragraph>
                    <Typography.Paragraph>Otherwise, the space prison will choose a nickname for you. Be aware that you may not like it.</Typography.Paragraph>
                    <Typography.Paragraph>🐭</Typography.Paragraph>
                    <div style={{ height: "12px" }} />
                    <Image src={require("../assets/blog/post_2022_02_13.png")} width={"240px"} style={{ border: "1px solid #262626" }} />
                </div>

                <div className="layout-content-element">
                    <Typography.Title level={2}>🏔 Updated roadmap</Typography.Title>
                    <Typography.Paragraph type='secondary'>Feb 12, 2022</Typography.Paragraph>
                    <Typography.Paragraph>Hello everyone, the head of the space prison decided to add additional items to our roadmap.</Typography.Paragraph>
                    <Typography.Paragraph>So, we have a lot of work ahead of us.</Typography.Paragraph>
                    <Typography.Paragraph>💪</Typography.Paragraph>
                    <div style={{ height: "12px" }} />
                    <Image src={require("../assets/blog/post_2022_02_12.png")} width={"240px"} style={{ border: "1px solid #262626" }} />
                </div>

                <div className="layout-content-element">
                    <Typography.Title level={2}>🤟 15 / 250</Typography.Title>
                    <Typography.Paragraph type='secondary'>Feb 11, 2022</Typography.Paragraph>
                    <Typography.Paragraph>Congratulate everyone. There are already 15 prisoners in our Crypto Space Prison.</Typography.Paragraph>
                    <Typography.Paragraph>There are 235 bad boys and girls running around somewhere else.</Typography.Paragraph>
                    <Typography.Paragraph>But it's a matter of time.</Typography.Paragraph>
                    <Typography.Paragraph>😈</Typography.Paragraph>
                    <div style={{ height: "12px" }} />
                    <Image src={require("../assets/blog/post_2022_02_11.png")} width={"240px"} style={{ border: "1px solid #262626" }} />
                </div>

                <Community />

                <Footer />

            </Layout.Content>
        </Layout>
    )
}